import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import classNames from 'classnames/bind';
import SelectMapPoint from '../../shared/SelectMapPoint/SelectMapPoint';
import styles from './AppControls.scss';

const cx = classNames.bind(styles);

const ConnectedSelectMapPoint = ({ showingSelectMapPoint, mapHolderOffset }) =>
  !!showingSelectMapPoint && (
    <SelectMapPoint
      className={cx('app-controls__select-map-point')}
      mapHolderOffset={mapHolderOffset}
      showingSelectMapPoint={showingSelectMapPoint}
    />
  );

ConnectedSelectMapPoint.propTypes = {
  showingSelectMapPoint: PropTypes.number.isRequired,
  mapHolderOffset: PropTypes.string,
};

ConnectedSelectMapPoint.defaultProps = {
  mapHolderOffset: '0px',
};

const mapStateToProps = (state) => ({
  showingSelectMapPoint: state.appControls.showingSelectMapPoint,
  mapHolderOffset: state.appControls.mapHolderOffset,
});

export default connect(mapStateToProps, {})(ConnectedSelectMapPoint);
